<template>
  <main-layout
    class="pro-rights-page"
    :page-title="text.rightsTitle"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="rights-header">
        <h1 class="rights-main-title">{{ text.planMainTitle }}</h1>
        <p class="rights-sub-title">{{ text.planSubTitle }}</p>
      </div>
      <!-- 本页为「区域未开通线上支付」时的联系客服页；设计稿 1896:16 仍保留
           「查看权益详情」（TEXT #1989:59），点击进入权益详情页（禅道 Bug#23427-2） -->
      <rights-section
        class="rights-block"
        :rights="rights"
        @more="goRightsDetail"
      />

      <div class="pay-bar">
        <el-button type="primary" class="kefu-btn" @click="kefuVisible = true">
          {{ text.contactKefu }}
        </el-button>
      </div>

      <kefu-dialog :visible.sync="kefuVisible" />
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import RightsSection from "./components/RightsSection.vue";
import KefuDialog from "./components/KefuDialog.vue";
import { PRO_PLAN_TEXT, PRO_PLAN_ROUTES } from "@/consts/proPlan";
import { getProPlanRights } from "@/api/request/snkd.proPlan";

/**
 * 专业版权益页：区域未开通线上支付时展示，仅支持联系客服
 */
export default {
  name: "ProPlanRights",
  components: { MainLayout, RightsSection, KefuDialog },
  data() {
    return {
      text: PRO_PLAN_TEXT,
      rights: [],
      kefuVisible: false,
    };
  },
  async created() {
    const res = await getProPlanRights();
    this.rights = res.obj || [];
  },
  methods: {
    // 进入权益详情页（9 大权益逐条说明）
    goRightsDetail() {
      this.$router.push({
        path: PRO_PLAN_ROUTES.rightsDetail,
        query: { companyId: this.$route.query.companyId },
      });
    },
    goBack() {
      window.history.length > 1 ? this.$router.back() : window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  min-height: 100%;
  padding: 30px 0 130px;
  box-sizing: border-box;
  background: #f7f9fb;
  position: relative;
}
.rights-header {
  text-align: center;
  .rights-main-title {
    margin: 0;
    font-size: 40px;
    font-weight: 400;
    color: #434343;
    line-height: 1.2;
  }
  .rights-sub-title {
    margin: 15px 0 0;
    font-size: 16px;
    color: #888;
    line-height: 24px;
  }
}
.rights-block {
  margin-top: 30px;
}
.pay-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 96px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  z-index: 10;
  .kefu-btn {
    width: 101px;
    height: 38px;
    padding: 0;
    border-radius: 10px;
    background: #0fa87b;
    border-color: #0fa87b;
    font-size: 16px;
    box-shadow: 0 4px 8px 0 rgba(50, 50, 71, 0.06),
      0 0 4px 0 rgba(50, 50, 71, 0.08);
  }
}
</style>
